module.exports = __webpack_public_path__ + "6fce3a19.svg";